export default __webpack_public_path__ + "static/media/LB.669c879d.svg";